import {MenuOutlined} from '@ant-design/icons';
import {Badge, Button} from 'antd';
import {jwtDecode} from 'jwt-decode';
import {useEffect, useState} from 'react';
import {AiOutlineHome} from 'react-icons/ai';
import {GiHeartNecklace} from 'react-icons/gi';
import {GrGallery} from 'react-icons/gr';
import {MdOutlineShoppingCart} from 'react-icons/md';
import {RiAccountBoxLine, RiContactsBook3Line, RiDashboardHorizontalLine} from 'react-icons/ri';
import {useSelector} from 'react-redux';
import {Link} from 'react-router-dom';

import logo from '../../assets/Images/Logo.png';
import {selectAuth} from '../../redux/selectors';

import {DrawerComponent} from './DrawerComponent';
import {NavOptions} from './NavOptions';

const Navbar = () => {
  const [open, setOpen] = useState(false);

  const [scrolled, setScrolled] = useState(false);

  const {totalQuantity} = useSelector(state => state.cart);

  const {loggedIn} = useSelector(state => state.auth);

  const auth = useSelector(selectAuth);

  const token = auth?.tokenData;

  let userRole = null;

  if (token) {
    try {
      const decodedToken = jwtDecode(token);
      userRole = decodedToken?.role;
    } catch (err) {
      console.error('Invalid token:', err.message);
    }
  }

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  const showDrawer = () => {
    setOpen(true);
  };

  const closeDrawer = () => {
    setOpen(false);
  };

  const navLinks = [
    {name: 'Home', path: '/', icon: <AiOutlineHome />},
    {name: 'About', path: '/about', icon: <RiContactsBook3Line />},
    {name: 'Product', path: '/product', icon: <GiHeartNecklace />},
  ];

  const items = [
    {name: 'Gallery', path: '/gallery', icon: <GrGallery />},

    ...(loggedIn
      ? [{name: 'Cart', path: '/cart', icon: <MdOutlineShoppingCart />}]
      : []),

    loggedIn
      ? userRole?.toLowerCase() === 'admin'
        ? {name: 'Dashboard', path: '/dashboard', icon: <RiDashboardHorizontalLine />}
        : {name: 'Profile', path: '/userhistory', icon: <RiAccountBoxLine />}
      : {name: 'Login', path: '/auth/login', icon: <RiAccountBoxLine />},
  ];

  return (
    <>
      <nav className={`fixed z-10 w-full bg-primary-800 transition-all duration-300 px-10 md:px-4 lg:px-20 xl:px-20 2xl:px-80 ${scrolled ? 'bg-opacity-95 py-2' : 'py-0'}`}>
        <div className={`hidden lg:flex w-full ${scrolled ? 'justify-center' : 'justify-between'}  gap-12 transition-all duration-300`}>
          {scrolled ? (
            <div className={'flex items-center justify-evenly w-full'}>
              {/*  logo when scrolled align to start*/}
              <Link to={'/'}>
                <img src={logo} className={'w-[60px]'} alt={'Logo'} />
              </Link>

              {/*  left side nav tabs when scrolled*/}
              {navLinks.map((link, index) => (
                <Link
                  key={index}
                  to={link.path}
                  className={'relative after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[1.3px] after:bg-white after:transition-all after:duration-300 hover:after:w-full'}
                >
                  <div className={'flex items-center text-white'}>
                    <span className={'text-lg mr-1'}>{link.icon}</span>
                    <span className={'text-lg mr-1'}>{link.name}</span>
                  </div>
                </Link>
              ))}

              {/*  right side nav tabs when scrolled*/}
              {items.map((item, index) => (
                <Link
                  key={index}
                  to={item.path}
                  className={'relative after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[1.3px] after:bg-white after:transition-all after:duration-300 hover:after:w-full'}
                >
                  <div className={'flex items-center text-white'}>
                    <span className={'text-xl mr-1'}>{item.icon}</span>
                    {item.name === 'Cart' ? (
                      <Badge style={{backgroundColor: '#b1a39f'}} count={totalQuantity} size={'small'} offset={[5, -2]}>
                        <span className={'text-lg mr-1 text-white'}>{item.name}</span>
                      </Badge>
                    ) : (
                      <span className={'text-lg mr-1 text-white'}>{item.name}</span>
                    )}
                  </div>
                </Link>
              ))}
            </div>
          ) : (
            <>
              {/*  left side nav tabs*/}
              <div className={'flex lg:gap-10 xl:gap-16 items-end text-white'}>
                {navLinks.map((link, index) => (
                  <Link key={index} to={link.path}
                    className={'relative after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[1.3px] after:bg-white after:transition-all after:duration-300 hover:after:w-full'}>
                    <div className={'flex items-center'}>
                      <span className={'text-lg mr-1'}>{link.icon}</span>
                      <span className={'text-lg mr-1'}>{link.name}</span>
                    </div>
                  </Link>
                ))}
              </div>

              {/*  logo position center*/}
              <Link to={'/'}>
                <img src={logo} className={'w-[100px] mt-2'} alt={'Logo'} />
              </Link>

              {/*  right side nav tabs*/}
              <div className={'flex lg:gap-10 xl:gap-16 items-end text-white'}>
                {items.map((item, index) => (
                  <Link key={index} to={item.path}
                    className={'relative after:absolute after:left-0 after:bottom-0 after:w-0 after:h-[1.3px] after:bg-white after:transition-all after:duration-300 hover:after:w-full'}>
                    <div className={'flex items-center'}>
                      <span className={'text-xl mr-1'}>{item.icon}</span>
                      {item.name === 'Cart' ? (
                        <Badge style={{backgroundColor: '#b1a39f'}} count={totalQuantity} size={'small'} offset={[5, -2]}>
                          <span className={'text-lg mr-1 text-white'}>{item.name}</span>
                        </Badge>
                      ) : (
                        <span className={'text-lg mr-1 text-white'}>{item.name}</span>
                      )}
                    </div>
                  </Link>
                ))}
              </div>
            </>
          )}
        </div>

        <div className={'flex justify-between items-center gap-5 lg:hidden ml-auto'}>
          <Link to={'/'}>
            <img src={logo} className={'w-[80px] my-2'} alt={'Logo'} />
          </Link>
          <Button
            type={'text'}
            icon={<span className={'text-xl text-white'}><MenuOutlined /></span>}
            onClick={showDrawer}
          />
        </div>
        {!scrolled && (
          <div className={'w-full pt-2 hidden lg:flex items-center justify-center'}>
            <div className={'flex-grow h-[2px] bg-gradient-to-l from-secondary-800 via-secondary-800 to-transparent'} />
            <div className={'flex-grow h-[2px] bg-gradient-to-r from-secondary-800 via-secondary-800 to-transparent'} />
          </div>
        )}
        {!scrolled && <NavOptions />}
        <DrawerComponent open={open} closeDrawer={closeDrawer} />
      </nav>
    </>
  );
};

export default Navbar;
